import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root {
    --violetaPastel: #cbb6db;
    --violetaOscuro: #4c048c;
    --violetaPastelOscuro: #743ca7;
    --violetaClaro: #9c74bc;
    --violeta: #780490;
    --naranja: #f4801a;
    --naranjaOscuro: #d4600a;
    --blanco: #fdfdfd;
    --gris: #f4f4f6;
    --grisOscuro: #17202a;
    --grisMedio: #8892a4;
    --sombra: 0 2px 12px rgba(76, 4, 140, 0.08);
    --sombraHover: 0 4px 20px rgba(76, 4, 140, 0.15);
    --radio: 8px;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Quicksand', sans-serif;
    overflow-x: hidden;
    background-color: #f8f7fc;
    color: var(--grisOscuro);
  }
`;
